import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getProductoById, getImageSignedUrl } from '../supabase/Productos';
import { useNumDocumento } from '../../context/AuthContext';
import Usuario from '../supabase/Usuario';
import { updateProductoEstado } from '../supabase/Productos';
import './ViewProduct.css';
import '../Home/Home.css';
import logo from '../Login/logo.png';
import logoVarita from "../Nido/varita.svg";

export default function ViewProduct() {
  const navigate = useNavigate();
  const { id } = useParams();
  const viewerNumDoc = useNumDocumento();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [viewerVaritas, setViewerVaritas] = useState(0);
  const [vendorName, setVendorName] = useState('Usuario');
  const [imgUrl, setImgUrl] = useState(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');
    (async () => {
      const { data, error } = await getProductoById(id);
      if (!mounted) return;
      if (error) setError('No se pudo cargar el producto');
      setItem(data);

      const path = data?.rutaImagen || data?.imgPath || data?.imgpath || data?.image_path || data?.imagePath;
      if (path) {
        const { url } = await getImageSignedUrl(path, 60 * 60);
        if (!mounted) return;
        setImgUrl(url || null);
      } else {
        setImgUrl(null);
      }

      if (viewerNumDoc) {
        const { data: cant, error: e1 } = await Usuario.getCantVaritas(viewerNumDoc);
        if (!mounted) return;
        if (!e1) setViewerVaritas(Number(cant || 0));
      }

      const docVend = data?.docusuario ?? data?.docUsuario;
      if (docVend) {
        const { data: vend, error: e2 } = await Usuario.getByNumDocumento(docVend);
        if (!mounted) return;
        if (!e2 && vend?.nombre) setVendorName(vend.nombre);
      }

      setLoading(false);
    })();
    return () => { mounted = false; };
  }, [id]);

  const isOwner = useMemo(() => {
    if (!item) return false;
    return String(item.docusuario ?? item.docUsuario ?? '') === String(viewerNumDoc ?? '');
  }, [item, viewerNumDoc]);

  const onBuy = () => {
    if (isOwner) return; 
    
    // Aqui va la logica de compra
    alert('La funcionalidad de compra no está implementada aún.');
  };

  const onBuyWithVaritas = async () => {
    if (isOwner) return;
    if (!viewerNumDoc || !item) return;

    try {
      const varitasPrice = Math.round(Number(item.precio || 0) * 0.5);
      const { data: latestVaritas } = await Usuario.getCantVaritas(viewerNumDoc);
      const currentVaritas = Number(latestVaritas || 0);
      if (currentVaritas < varitasPrice) {
        alert('No te alcanzan las varitas para esta compra.');
        return;
      }

      const okRemove = await Usuario.removerVaritas(viewerNumDoc, varitasPrice);
      if (!okRemove) { alert('No fue posible debitar varitas.'); return; }

      const refund = Math.floor(varitasPrice * 0.10);
      if (refund > 0) {
        const okAdd = await Usuario.agregarVaritas(viewerNumDoc, refund);
        if (!okAdd) {
          // No detenemos la compra, pero informamos
          console.warn('No se pudo acreditar el 10% de varitas de devolución.');
        }
      }

      const docVendCredito = item?.docusuario ?? item?.docUsuario;
      if (docVendCredito) {
        const okVend = await Usuario.agregarVaritas(docVendCredito, varitasPrice);
        if (!okVend) {
          console.warn('No se pudo acreditar varitas al vendedor.');
        }
      } else {
        console.warn('No se pudo determinar el documento del vendedor para acreditar varitas.');
      }

      console.log('[purchase] actualizar estado de producto a 2, id:', item.id);
      const { data: updRes, error: updErr } = await updateProductoEstado(item.id, 2);
      console.log('[purchase] resultado updateProductoEstado:', { updRes, updErr });
      if (updErr) {
        console.warn('No se pudo actualizar el estado del producto:', updErr);
      }

      const docVend = item?.docusuario ?? item?.docUsuario;
      let telefono = '—';
      let correo = '—';
      if (docVend) {
        const { data: userRow, error: e3 } = await Usuario.getByNumDocumento(docVend);
        if (userRow) {
          telefono = userRow.numTelefono;
          correo = userRow.correo;
        }
      }
      const purchase = Usuario.comprar(viewerNumDoc, item.id);
      if (purchase){
          navigate('/purchase/confirmation', { state: { telefono, correo } });
      }
    } catch (e) {
      console.error('Error en compra con varitas:', e);
      alert('Ocurrió un error realizando la compra.');
    }
  };

  const onBack = () => navigate('/home');

  if (loading) return (
    <div className="app-container">
      <div className="vp-page">
        <header className="topbar" role="banner">
          <div className="brand">
            <img src={logo} alt="logo" onClick={() => navigate('/home')} className="brand-logo" />
            <nav className="nav" aria-label="navegación principal">
              <button className="nav-link active" onClick={() => navigate('/home')}>Inicio</button>
              <button className="nav-link" onClick={() => navigate('/profile')}>Mi nido</button>
            </nav>
          </div>
          <div className="right" />
          <title>ReANIDArt - Producto</title>
        </header>

        <main className="vp-content" role="main" aria-busy>
          <section className="vp-card skeleton-card">
            <div className="vp-left">
              <div className="vp-skeleton vp-skel-thumb" aria-hidden />
            </div>
            <div className="vp-right">
              <div className="vp-right-top">
                <div className="vp-badges">
                  <div className="vp-skeleton vp-skel-badge" />
                  <div className="vp-skeleton vp-skel-badge" />
                </div>
              </div>

              <div className="vp-skeleton vp-skel-title" />
              <div className="vp-skeleton vp-skel-line" />
              <div className="vp-skeleton vp-skel-line short" />

              <div className="vp-info">
                <div className="vp-skeleton vp-skel-info" />
                <div className="vp-skeleton vp-skel-info" />
              </div>

              <div className="vp-actions">
                <div className="vp-skeleton vp-skel-btn" />
                <div className="vp-skeleton vp-skel-btn" />
                <div className="vp-skeleton vp-skel-btn" />
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
  if (error) return (<div className="vp-page"><div className="vp-error">{error}</div></div>);
  if (!item) return (<div className="vp-page"><div className="vp-error">Producto no encontrado</div></div>);

  return (
      <div className="app-container">
          <div className="vp-page">
          <header className="topbar" role="banner">
            <div className="brand">
              <img src={logo} alt="logo" onClick={() => navigate('/home')} className="brand-logo" />
              <nav className="nav" aria-label="navegación principal">
                <button className="nav-link active" onClick={() => navigate('/home')}>Inicio</button>
                <button className="nav-link" onClick={() => navigate('/profile')}>Mi nido</button>
              </nav>
            </div>
            <div className="right" />
              <title>ReANIDArt - Producto</title>
          </header>

          <main className="vp-content" role="main">
            <section className="vp-card" role="region" aria-labelledby="vp-title">
              <div className="vp-left">
                <div className="vp-thumb" aria-hidden>
                  {imgUrl
                    ? <img className="vp-thumb-img" src={imgUrl} alt={item?.titulo || 'Producto'} />
                    : <div className="vp-placeholder" />}
                </div>
              </div>
              <div className="vp-right">
                <div className="vp-right-top">
                  <div className="vp-badges">
                    <div className="vp-badge" title="Precio en varitas">
                        <img src={logoVarita} alt="logo cantidad de varitas"/>
                        <span className="vp-badge-text">{Math.round(Number(item.precio*0.5)).toLocaleString('es-CR')}</span>
                    </div>
                    <div className="vp-badge">
                      <span className="vp-badge-icon">₡</span>
                      <span className="vp-badge-text">{Number(item.precio ?? 0).toLocaleString('es-CR')}</span>
                    </div>
                  </div>
                </div>

                <h1 id="vp-title" className="vp-title">{item.titulo || 'Producto'}</h1>
                <p className="vp-desc">{item.descripcion || 'Descripción del producto.'}</p>

                <div className="vp-info">
                  <div className="vp-info-row">
                    <div className="vp-info-label">Vendedor</div>
                    <div className="vp-info-value">{vendorName}</div>
                  </div>
                  <div className="vp-info-row">
                    <div className="vp-info-label">Ubicación</div>
                    <div className="vp-info-value">{item.direccion || 'Ubicación'}</div>
                  </div>
                </div>

                <div className="vp-actions">
                  <button className="vp-btn" onClick={onBack}>Volver</button>
                  <span title={isOwner ? 'No puedes comprar tu propio producto' : undefined}>
                    <button className="vp-btn primary" onClick={onBuy} disabled={isOwner} aria-label={isOwner ? 'Comprar (deshabilitado: eres el dueño)' : 'Comprar'}>
                      Comprar
                    </button>
                  </span>
                  <span title={isOwner ? 'No puedes comprar tu propio producto' : undefined}>
                    <button className="vp-btn" onClick={onBuyWithVaritas} disabled={isOwner} aria-label={isOwner ? 'Comprar con varitas (deshabilitado: eres el dueño)' : 'Comprar con varitas'}>
                      Comprar con varitas
                    </button>
                  </span>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
  );
}
